import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { TabularTypeDatasetAdapter, tabularPropertiesCommonAdapts } from './tabular-type.dataset.adapter';
import { DynamicsAXResourceDataset } from 'app/model/dataset/dynamics-ax-resource.dataset';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(DynamicsAXResourceDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            ...tabularPropertiesCommonAdapts,
            typeProperties: {
                path: '*'
            }
        }
    }
})
export class DynamicsAXResourceDatasetAdapter extends TabularTypeDatasetAdapter<DynamicsAXResourceDataset, Model.DatasetResource> {
    protected async _toResource(dataset: DynamicsAXResourceDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(DynamicsAXResourceDataset).name, 'path');
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: DynamicsAXResourceDataset): Promise<DynamicsAXResourceDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, DynamicsAXResourceDataset.MODEL, 'path');
    }
}
